import React from 'react'
import { FormControl, InputBase, type InputBaseProps } from '@mui/material'

import './AccessibleGrid.scss'

interface CellTextInputProps extends InputBaseProps {
  id?: string
}

const CellTextInput: React.FC<CellTextInputProps> = ({
  placeholder = '',
  type,
  id,
  readOnly,
  ...props
}) => {
  return (
    <FormControl variant='standard' className='cell-text-input'>
      <InputBase
        id={id || 'text-input'}
        placeholder={placeholder}
        type={type}
        readOnly={readOnly}
        className={`cell-text-input-base${readOnly ? ' cell-text-input-base--readonly' : ''}`}
        {...props}
      />
    </FormControl>
  )
}

export default CellTextInput
